const getPipeHeaderConfig = (variant) => {
  const variantsConfigs = {
    defaultConfig: [
      { path: "/01-step/" },
      { path: "/02-step/" },
      { path: "/03-step/" },
      { path: "/04-step/" },
      { path: "/05-step/" },
      { path: "/06-step/" },
      { path: "/07-step/" },
      { path: "/08-step/" },
      { path: "/09-step/" },
      { path: "/10-step/" },
      { path: "/11-step/" },
      { path: "/12-step/" },
      { path: "/13-step/" },
      { path: "/14-step/" },
      { path: "/15-step/" },
      { path: "/16-step/" },
      { path: "/17-step/" },
      { path: "/18-step/" },
      { path: "/19-step/" },
      { path: "/20-step/" },
      { path: "/21-step/" },
      { path: "/22-step/" },
      { path: "/23-step/" },
      { path: "/24-step/" },
      { path: "/25-step/" },
      { path: "/26-step/" },
      { path: "/27-step/" },
      { path: "/28-step/" },
      { path: "/29-step/" },
      { path: "/30-step/" },
      { path: "/31-step/" },
      { path: "/32-step/" },
      { path: "/33-step/" },
      { path: "/34-step/" },
      { path: "/35-step/" },
      { path: "/36-step/" },
    ],
    TikTok: [
      { path: "/01-step/" },
      { path: "/02-step/" },
      { path: "/03-step/" },
      { path: "/04-step/" },
      { path: "/05-step/" },
      { path: "/06-step/" },
      { path: "/07-step/" },
      { path: "/08-step/" },
      { path: "/09-step/" },
      { path: "/10-step/" },
      { path: "/11-step/" },
      { path: "/12-step/" },
      { path: "/13-step/" },
      { path: "/14-step/" },
      { path: "/15-step/" },
      { path: "/16-step/" },
      { path: "/17-step/" },
      { path: "/18-step/" },
      { path: "/19-step/" },
      { path: "/20-step/" },
      { path: "/21-step/" },
      { path: "/22-step/" },
      { path: "/23-step/" },
      { path: "/24-step/" },
      { path: "/25-step/" },
      { path: "/26-step/" },
      { path: "/27-step/" },
      { path: "/28-step/" },
      { path: "/29-step/" },
      { path: "/30-step/" },
      { path: "/31-step/" },
      { path: "/32-step/" },
      { path: "/34-step/" },
      { path: "/35-step/" },
      { path: "/36-step/" },
    ],
    "Applovin Primary": [
      { path: "/01-step/" },
      { path: "/02-step/" },
      { path: "/03-step/" },
      { path: "/04-step/" },
      { path: "/05-step/" },
      { path: "/06-step/" },
      { path: "/07-step/" },
      { path: "/08-step/", skipCount: true },
      { path: "/09-step/" },
      { path: "/10-step/" },
      { path: "/11-step/" },
      { path: "/12-step/", skipCount: true },
      { path: "/13-step/" },
      { path: "/14-step/" },
      { path: "/15-step/" },
      { path: "/16-step/" },
      { path: "/17-step/" },
      { path: "/18-step/" },
      { path: "/19-step/" },
      { path: "/20-step/" },
      { path: "/21-step/", skipCount: true },
      { path: "/22-step/" },
      { path: "/23-step/" },
      { path: "/24-step/", skipCount: true },
      { path: "/25-step/" },
      { path: "/26-step/" },
      { path: "/27-step/" },
      { path: "/28-step/" },
      { path: "/29-step/" },
      { path: "/30-step/", skipCount: true },
      { path: "/31-step/" },
      { path: "/32-step/", skipCount: true },
      { path: "/33-step/", skipCount: true },
    ],
    "Keto Eggs v2 Discount Code": [
      { path: "/01-step/" },
      { path: "/02-step/" },
      { path: "/03-step/" },
      { path: "/04-step/" },
      { path: "/05-step/" },
      { path: "/06-step/" },
      { path: "/07-step/" },
      { path: "/08-step/" },
      { path: "/09-step/" },
      { path: "/10-step/" },
      { path: "/11-step/" },
      { path: "/12-step/" },
      { path: "/13-step/" },
      { path: "/14-step/" },
      { path: "/15-step/" },
      { path: "/16-step/" },
      { path: "/17-step/" },
      { path: "/18-step/" },
      { path: "/19-step/" },
      { path: "/20-step/" },
      { path: "/21-step/" },
      { path: "/22-step/" },
      { path: "/23-step/" },
      { path: "/24-step/" },
      { path: "/25-step/" },
      { path: "/26-step/" },
      { path: "/27-step/" },
      { path: "/28-step/" },
      { path: "/29-step/" },
      { path: "/30-step/" },
      { path: "/31-step/" },
      { path: "/32-step/" },
      { path: "/33-step/" },
      { path: "/34-step/" },
      { path: "/35-step/" },
      { path: "/36-step/" },
    ],
    "K3 Nutritionist Chat":[
      { path: "/01-step/" },
      { path: "/02-step/" },
      { path: "/03-step/" },
      { path: "/04-step/" },
      { path: "/05-step/" },
      { path: "/06-step/" },
      { path: "/07-step/" },
      { path: "/08-step/" },
      { path: "/09-step/" },
      { path: "/10-step/" },
      { path: "/11-step/" },
      { path: "/12-step/" },
      { path: "/13-step/" },
      { path: "/stepNutritionist/" },
      { path: "/14-step/" },
      { path: "/15-step/" },
      { path: "/16-step/" },
      { path: "/17-step/" },
      { path: "/18-step/" },
      { path: "/19-step/" },
      { path: "/20-step/" },
      { path: "/21-step/" },
      { path: "/22-step/" },
      { path: "/23-step/" },
      { path: "/24-step/" },
      { path: "/25-step/" },
      { path: "/stepDiseases/" },
      { path: "/stepAdditionalGoal/" },
      { path: "/stepChat/" },
      { path: "/stepReachGoal/" },
      { path: "/stepFaceChange/" },
      { path: "/35-step/" },
      { path: "/36-step/" },
    ]
  }

  return variantsConfigs[variant] || variantsConfigs.defaultConfig
}

export default getPipeHeaderConfig
